import React from 'react';
import { Tabs, Tab } from '@mui/material';
import ColorPalette from '../../../../colorpalette/ColorPalette';

const TabNavigation = ({ activeTab, handleTabChange }) => {
  return (
    <Tabs
      value={activeTab}
      onChange={handleTabChange}
      sx={{
        marginBottom: '24px',
        '& .MuiTab-root': {
          textTransform: 'none',
          fontWeight: 500,
          color: ColorPalette.textMedium,
          '&.Mui-selected': {
            color: ColorPalette.secondary,
            fontWeight: 600
          }
        },
        '& .MuiTabs-indicator': {
          backgroundColor: ColorPalette.secondary
        }
      }}
    >
      <Tab label="1. Selecionar Destinatários" />
      <Tab label="2. Compor Mensagem" />
      <Tab label="3. Revisar e Enviar" />
    </Tabs>
  );
};

export default TabNavigation;